import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import showdown from "showdown";


// components
import UserSubscriberContext from "../../context/UserSubscriberContext";


class MaterialTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            content: null
        };
    }

    async componentDidMount(){
        let content = this.props.material.text
        if (this.props.material.xformat === 'MD') {
            let parser = new showdown.Converter(
                {
                    tables: true,
                    noHeaderId: true,
                    simplifiedAutoLink: true,
                    openLinksInNewWindow: true,
                }
            )
            content = parser.makeHtml(content)
        }
        if (this.props.material.xformat === 'PDF') {
            content = `<iframe
                src="data:application/pdf;base64,${content}"
                width="100%"
                height="100%"
                style="border: none"
            />`
        }
        this.setState(
            {
                content: content
            }
        )
    }

    render() {
        if (!this.state.content) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={1}
                sx={{
                    height: '100%'
                }}
            >

                <div
                    style={{
                        height: '100%'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: this.state.content
                    }}
                />
            </Stack>
        )
    }
}

export default MaterialTab;
